/* WOW FINCA – Preis auf Finca-Kacheln (03.11.2026, Thorsten).
   v2 (20:12, „1.477 € steht doppelt – man versteht es nicht, den Leser führen“):
   Ohne Zeitraum: Bild-Schild „ab … € pro Nacht“ wie bisher.
   Mit Zeitraum (Kasten .wowc__free.is-z): Bild-Schild verschwindet, der Kasten wird EIN klarer Preisblock:
     Zeile 1 (klein):  Mi 9.12. – Fr 18.12. · 9 Nächte
     Zeile 2 (groß):   1.477 €   ≈ 82 € p. P./Nacht
   Zahlen werden nur aus dem gerenderten Kasten gelesen (gleiche Quelle, keine eigene Rechnung). Geladen über snippets/wow-i18n. */
(function () {
  if (window.__wowPs) return; window.__wowPs = 1;
  /* 20:13 Thorsten: Sprüche „Passt, weil …“ unter dem Preis stören → ausgeblendet */
  var css = '.wowc__why{display:none!important}.wowc__c.wps-on .wowc__price{display:none!important}' +
    '.wowc__free.wps{display:block!important;background:none!important;padding:0!important;margin:12px 0 0!important;border:0!important}' +
    '.wowc__free.wps>i,.wowc__free.wps>div:not(.wps__w),.wowc__free.wps>span{display:none!important}' +
    '.wps__d{margin:0;font-size:12.5px;color:#6f675f;line-height:1.35}.wps__d b{color:#141414;font-weight:600}' +
    '.wps__p{margin:2px 0 0;display:flex;align-items:baseline;gap:8px;flex-wrap:wrap}.wps__p b{font-size:22px;font-weight:700;color:#141414;letter-spacing:-.01em}' +
    '.wps__p span{font-size:12.5px;color:#6f675f}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  function cl(el, c, on) { if (el && el.classList.contains(c) !== on) el.classList.toggle(c, on); }
  function e(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function upd(c) {
    var f = c.querySelector('.wowc__free'), ok = f && !f.hidden && f.classList.contains('is-z');
    var old = f && f.querySelector(':scope > .wps__w');
    if (!ok) { cl(c, 'wps-on', false); if (f) { cl(f, 'wps', false); if (old) old.remove(); } return; }
    var s = f.querySelector(':scope > span'), d = f.querySelector(':scope > div:not(.wps__w)');
    var total = s ? s.textContent.trim() : '';
    if (!total || !d) { cl(c, 'wps-on', false); cl(f, 'wps', false); if (old) old.remove(); return; }
    var b = d.querySelector('b'), dates = b ? b.textContent.trim() : '';
    var rest = d.textContent.replace(b ? b.textContent : '', '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
    var parts = rest.split('·').map(function (x) { return x.trim(); }).filter(Boolean);
    var nights = parts[0] || '', pp = parts.slice(1).join(' · ');
    var html = '<p class="wps__d"><b>' + e(dates) + '</b>' + (nights ? ' · ' + e(nights) : '') + '</p>' +
      '<p class="wps__p"><b>' + e(total) + '</b>' + (pp ? '<span>' + e(pp) + '</span>' : '') + '</p>';
    if (!old) { old = document.createElement('div'); old.className = 'wps__w'; f.appendChild(old); }
    if (old.innerHTML !== html) old.innerHTML = html;
    cl(f, 'wps', true); cl(c, 'wps-on', true);
  }
  function all() { document.querySelectorAll('.wowc__c').forEach(upd); }
  var q = 0;
  function later() { if (q) return; q = requestAnimationFrame(function () { q = 0; all(); }); }
  /* 03.11.2026 21:10 (flüssig): Klassen nur noch ändern, wenn sie sich wirklich ändern (vorher Endlosschleife ~35.000 Mutationen/s),
     Beobachter nur auf den Bereich mit den Kacheln, eigene Änderungen ignoriert. */
  function boot() {
    all();
    var root = document.querySelector('main') || document.body;
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var m = ms[i], t = m.target;
        if (t.closest && t.closest('.wps__w')) continue;
        if (m.type === 'attributes') { if (t.classList && t.classList.contains('wowc__free')) { later(); return; } continue; }
        if (m.addedNodes.length || m.removedNodes.length) { later(); return; }
      }
    }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
